import {Component, input, ChangeDetectionStrategy} from '@angular/core';

import {ApiService} from '../../_services/api.service';
import {FormItem} from '../../_models/formitem';
import {FormListRowComponent} from './form-list-row/form-list-row.component';

@Component({
    selector: 'app-form-list',
    imports: [
    FormListRowComponent
],
    templateUrl: './form-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-list.component.scss'
})
export class FormListComponent {
  forms = input.required<FormItem[]>();

  constructor(protected apiService: ApiService) {
  }
}
